/* ========================================================================
   Navigation
 ========================================================================== */

app.navigation = (function () {
  'use strict';

  const KEY_ENTER = 'Enter';
  const KEY_SPACE = 'Space';
  const KEY_ESCAPE = 'Escape';

  let _isKeyboardEvent = false;
  let _focusEl = null;
  const _trigger = document.querySelector('[data-nav-trigger]');
  const _container = document.querySelector('[data-nav-container]');
  const _body = document.querySelector('body');
  const _mediaQueryBreakpoint = window.matchMedia('(max-width: 991.98px)');

  //
  // Menu
  //

  /**
   * Initialize the main navigation
   */
  function init() {
    if (!_container || !_trigger) return;

    // Add event listener to close menu (close on ESC)
    document.addEventListener('keydown', (event) => {
      if (event.code === KEY_ESCAPE) {
        _isKeyboardEvent = true;
        closeNav();
      }
    });

    // Add event listener to open button
    _trigger.addEventListener('click', (event) => {
      _isKeyboardEvent = util.isKeyboardEvent(event);
      toggleNav();
    });

    // Close all open submenus when clicking outside navigation
    document.addEventListener('click', (event) => {
      if (event.target.classList.contains('page-wrapper')) {
        if (_body.getAttribute('data-menu') === 'open') {
          _isKeyboardEvent = util.isKeyboardEvent(event);
          closeNav();
        }
      }
    });

    // Add event listener for media query
    _mediaQueryBreakpoint.addEventListener('change', onMediaQueryChange);
    onMediaQueryChange();
  }

  /**
   * Toggle the mobile navigation
   */
  function toggleNav() {
    if (_trigger.getAttribute('aria-expanded') === 'false') {
      openNav();
    } else {
      closeNav();
    }
  }

  /**
   * Open the mobile navigation
   */
  function openNav() {
    _trigger.setAttribute('aria-expanded', 'true');
    _container.setAttribute('visible', '');
    _body.setAttribute('data-menu', 'open');

    // a11y: Focus back on first focusable element in the menu
    if (_isKeyboardEvent) {
      const firstLink = _container.querySelector('a[href]');
      if (firstLink) {
        firstLink.focus();
      }
    }
  }

  /**
   * Close the mobile navigation
   */
  function closeNav() {
    _trigger.setAttribute('aria-expanded', 'false');
    _container.removeAttribute('visible');
    _body.setAttribute('data-menu', 'closing');

    // a11y: Focus back on open button after closing the menu
    if (_isKeyboardEvent) {
      _trigger.focus();
      _focusEl = null;
    }
  }

  /**
   * Handle media query change event (switch between small and large screens)
   */
  function onMediaQueryChange() {
    // Close mobile navigation on larger screens
    if (_mediaQueryBreakpoint.matches === false) {
      closeNav();
    }
  }

  // Expose public functions and variables
  return {
    init: init,
  };
})();
